import React, {useEffect, useState} from 'react';
import ScrollTrigger from "gsap/ScrollTrigger";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import gsap from "gsap";
import Line1 from "@/Components/Front/SVGS/Line1";
import useNormalizedPosition from "@/Hooks/useNormalizedPosition";
import LineColor1 from "@/Components/Front/SVGS/Colors/LineColor1";
import LineColor2 from "@/Components/Front/SVGS/Colors/LineColor2";
import LineColor3 from "@/Components/Front/SVGS/Colors/LineColor3";
import LineColor4 from "@/Components/Front/SVGS/Colors/LineColor4";
import LineColor5 from "@/Components/Front/SVGS/Colors/LineColor5";
import LineColor6 from "@/Components/Front/SVGS/Colors/LineColor6";


gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);


const Graph = ({line}) => {
    const [progress, setProgress] = React.useState(0);
    const [pathLength, setPathLength] = useState();
    const line1Ref = React.useRef(null);



    const [normalizedPosition, setMaxValue, setScrollProgress] = useNormalizedPosition();


    useEffect(() => {

        gsap.timeline({
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: "#line-color-" + line,
                // markers: {startColor: "white", endColor: "white"},
                scrub: true,
                start: "top center",
                end: "bottom center",
                onUpdate: self => {
                    setProgress(self.progress.toFixed(3));
                    setScrollProgress(self.progress.toFixed(3));
                }

            }
        })

    }, [])

    useEffect(
        () => {
            if (line1Ref.current) {
                const pathLength = line1Ref.current.getTotalLength();

                setPathLength(pathLength)
                setMaxValue(pathLength);
            }
        },
        [line1Ref]
    )
    return (
        <div className={"graph"}>
            { line === 1 &&  <LineColor1 key="line-1" ref={line1Ref}  normalizedPosition={normalizedPosition} pathLength={pathLength} /> }
            { line === 2 &&  <LineColor2 key="line-2" ref={line1Ref}  normalizedPosition={normalizedPosition} pathLength={pathLength} /> }

            { line === 3 &&  <LineColor3 ref={line1Ref}  normalizedPosition={normalizedPosition} pathLength={pathLength} /> }
            { line === 4 &&  <LineColor4 ref={line1Ref}  normalizedPosition={normalizedPosition} pathLength={pathLength} /> }
            { line === 5 &&  <LineColor5 ref={line1Ref}  normalizedPosition={normalizedPosition} pathLength={pathLength} /> }
            { line === 6 &&  <LineColor6 ref={line1Ref}  normalizedPosition={normalizedPosition} pathLength={pathLength} /> }

        </div>

    )
}

export default Graph;
